import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

export class LimitedDateRangePicker extends React.Component {
  static propTypes = {
    click30Day: PropTypes.func,
    click60Day: PropTypes.func,
    displayedDates: PropTypes.shape({
      dayCount: PropTypes.number,
    }),
  };

  render() {
    // The crazy button class stack here is to get a combo of ds styles and
    // old btn-group styles
    const buttonClasses =
      'btn btn-default u-fw700 u-tcGrayDarkest Button Button--inverseGray Button--sm u-borderColorGray u-hover-bgColorGray u-textCapitalize';
    const button30Classes = classNames(buttonClasses, {
      active: this.props.displayedDates.dayCount === 30,
    });
    const button60Classes = classNames(buttonClasses, {
      active: this.props.displayedDates.dayCount === 60,
    });
    return (
      <div className="btn-group" style={{ zIndex: 0 }}>
        <button className={button30Classes} onClick={this.props.click30Day}>
          30 Days
        </button>
        <button className={button60Classes} onClick={this.props.click60Day}>
          60 Days
        </button>
      </div>
    );
  }
}
